import React, { FC } from 'react';
import NavLink from 'app/components/presentation/nav/NavLink';
import { NavigationType, NavigationContext } from 'app/components/header/navigation/Navigation';
import { INavigationItemProps } from 'app/components/header/navigation/NavigationItem';
import { useCss } from 'app/utils/css';
import NavDropdown from 'app/components/presentation/nav/NavDropdown';
import Options from 'app/components/svgs/Options';
import { INavigationLinkProps } from 'app/components/header/navigation/NavigationLink';
import { INavigationSectionProps } from 'app/components/header/navigation/NavigationSection';
import { COLOR_PALETTE } from 'app/constants/ColorPalette';
import { useHoverState } from '@engoo/react-hover-state';
import { getNavLinkStyles } from 'app/components/presentation/nav/styles';

/**
 * @private Do not use directly except in tests and stories. Use {@link Navigation} instead
 */
export const DropdownNavigation: FC = ({ children }) => {
  const css = useCss();
  return (
    <NavigationContext.Provider value={{ type: NavigationType.Dropdown }}>
      <NavDropdown icon={<Options size="30px" />} showArrow={false} width="200px">
        <ul
          className={css('list', {
            listStyle: 'none',
            padding: 0,
            margin: 0,
          })}
        >
          {children}
        </ul>
      </NavDropdown>
    </NavigationContext.Provider>
  );
};

/**
 * @private Do not use directly except in tests and stories. Use {@link NavigationSection} instead
 */
export const DropdownSection: FC<INavigationSectionProps> = ({
  children,
  ...props
}) => {
  const css = useCss();
  return (
    <li>
      <ul
        className={css('section', {
          listStyle: 'none',
          margin: 0,
          padding: 0,
          borderBottom: `1px solid ${COLOR_PALETTE.grey.base}`,
          ':empty': {
            display: 'none',
          },
        })}
        {...props}
      >
        {children}
      </ul>
    </li>
  );
};

/**
 * @private Do not use directly except in tests and stories. Use {@link NavigationItem} instead
 */
export const DropdownItem: FC<INavigationItemProps> = ({ children }) => {
  const css = useCss();
  const [hovered, hoverRef] = useHoverState();
  return (
    <li
      className={css(
        'dropdownItem',
        getNavLinkStyles({ active: false, logo: false, hovered, selected: false }),
      )}
      ref={hoverRef}
    >
      {children}
    </li>
  );
};

/**
 * @private Do not use directly except in tests and stories. Use {@link NavigationLink} instead
 */
export const DropdownLink: FC<INavigationLinkProps> = ({ children, icon, selected, ...linkProps }) => (
  <li>
    <NavLink selected={selected} {...linkProps}>
      {children}
    </NavLink>
  </li>
);
